import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { openPdf } from "@/lib/pdf";
import { FileText, XCircle } from "lucide-react";
import { toast } from "sonner";

export default function Tickets() {
  const [tickets, setTickets] = useState([]);
  const [filter, setFilter] = useState("");

  const load = () => api.get("/tickets").then((r) => setTickets(r.data));
  useEffect(() => { load(); }, []);

  const cancel = async (id) => {
    if (!window.confirm("Ticket stornieren?")) return;
    await api.post(`/tickets/${id}/cancel`);
    toast.success("Storniert");
    load();
  };

  const filtered = tickets.filter((t) =>
    !filter ||
    t.ticket_number.toLowerCase().includes(filter.toLowerCase()) ||
    (t.guest_name || "").toLowerCase().includes(filter.toLowerCase()) ||
    (t.movie_title || "").toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div className="space-y-6" data-testid="tickets-page">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#A8A398]">Buchungen</div>
          <h1 className="font-heading text-2xl sm:text-3xl md:text-4xl">Tickets</h1>
        </div>
        <input value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Suchen …"
          className="bg-[#050505] border border-[#2A2A2A] rounded px-3 py-2 text-sm focus:border-[#D4AF37] outline-none w-full sm:w-64" />
      </div>
      <div className="card-lux overflow-hidden">
        <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[820px]">
          <thead className="bg-[#0A0A0A] border-b border-[#1A1A1A] text-[#A8A398] text-xs uppercase tracking-widest">
            <tr>
              <th className="text-left p-3">Nummer</th>
              <th className="text-left p-3">Film</th>
              <th className="text-left p-3">Datum</th>
              <th className="text-left p-3">Reihe/Platz</th>
              <th className="text-left p-3">Gast</th>
              <th className="text-left p-3">Preis</th>
              <th className="text-left p-3">Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((t) => (
              <tr key={t.id} className="border-b border-[#141414]" data-testid={`ticket-row-${t.id}`}>
                <td className="p-3 font-mono text-[#D4AF37] whitespace-nowrap">{t.ticket_number}</td>
                <td className="p-3">{t.movie_title}</td>
                <td className="p-3 font-mono whitespace-nowrap">{t.date} {t.start_time}</td>
                <td className="p-3 font-mono">{t.row}{t.seat}</td>
                <td className="p-3">{t.guest_name}</td>
                <td className="p-3 whitespace-nowrap">{t.price?.toFixed(2)} €</td>
                <td className="p-3">
                  <span className="text-[10px] uppercase tracking-widest border border-[#2A2A2A] rounded-full px-2 py-0.5">{t.status}</span>
                </td>
                <td className="p-3 text-right whitespace-nowrap">
                  <a href={`${process.env.REACT_APP_BACKEND_URL}/api/tickets/${t.id}/pdf`} target="_blank" rel="noreferrer"
                    onClick={(e) => { e.preventDefault(); openPdf(`/tickets/${t.id}/pdf`); }}
                    className="text-xs px-2 py-1 border border-[#2A2A2A] rounded hover:border-[#D4AF37] mr-2 inline-flex items-center gap-1">
                    <FileText size={12} /> PDF
                  </a>
                  <button onClick={() => cancel(t.id)} className="text-xs px-2 py-1 border border-[#2A2A2A] rounded hover:border-[#7A1921] inline-flex items-center gap-1">
                    <XCircle size={12} /> Stornieren
                  </button>
                </td>
              </tr>
            ))}
            {!filtered.length && <tr><td colSpan={8} className="p-8 text-center text-[#A8A398]">Keine Tickets</td></tr>}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
